
import React from 'react';
import { Handle, Position } from '@xyflow/react';
import NodeHeader from './NodeHeader';
import TriggerSettings from './settings/TriggerSettings';
import SendMessageSettings from './settings/SendMessageSettings';
import AiSettings from './settings/AiSettings';
import KnowledgeBaseSettings from './settings/KnowledgeBaseSettings';
import ConditionalSettings from './settings/ConditionalSettings';
import ApiCallSettings from './settings/ApiCallSettings';

const SETTINGS_COMPONENTS = {
  trigger: TriggerSettings,
  send_message: SendMessageSettings,
  ai: AiSettings,
  knowledge_base: KnowledgeBaseSettings,
  conditional: ConditionalSettings,
  api_call: ApiCallSettings
};

export default function EditableNode({ data, selected }) {
  // console.log("data ::", data)
  const cfg = data.config;
  const update = data.onPatch;
  const Settings = SETTINGS_COMPONENTS[data.kind];
  const isTrigger = data.kind === 'trigger';

  return (
    <div className={`min-w-[290px] md:min-w-[360px] max-w-[500px] rounded-xl border bg-white p-2 shadow-[0_8px_24px_rgba(15,23,42,0.1)] ${selected ? 'border-green-500 ring-2 ring-green-500/25' : 'border-blue-100'}`}>
      {!isTrigger ? <Handle type="target" position={Position.Top} /> : null}

      <NodeHeader data={data} />

      <div className="mt-2 flex gap-2">
        <button className="nodrag rounded-md border border-slate-300 bg-white px-2 py-1 text-xs font-semibold text-slate-900" onClick={data.onDuplicate}>Duplicate</button>
        <button className="nodrag rounded-md border border-red-200 bg-red-50 px-2 py-1 text-xs font-semibold text-red-700" onClick={data.onRemove}>Delete</button>
      </div>

      {Settings ? <Settings cfg={cfg} data={data} update={update} /> : null}

      {data.kind === 'trigger' ? (
        <Handle type="source" position={Position.Right} />
      ) : data.kind === 'conditional' ? (
        <>
          {/* TRUE branch */}
          <Handle
            id="true"
            type="source"
            position={Position.Right}
            className="!bg-green-500"
          />

          <span
            className="absolute right-[-34px] top-1/2 -translate-y-1/2 text-[10px] font-semibold text-green-600 pointer-events-none"
          >
            TRUE
          </span>

          {/* FALSE branch */}
          <Handle
            id="false"
            type="source"
            position={Position.Bottom}
            className="!bg-red-500"
          />

          <span
            className="absolute bottom-[-18px] left-1/2 -translate-x-1/2 text-[10px] font-semibold text-red-600 pointer-events-none"
          >
            FALSE
          </span>
        </>
      ) : (
        <Handle type="source" position={Position.Bottom} />
      )}
    </div>
  );
}


// { : (
//   <Handle type="source" position={Position.Bottom} />
// )}
